import axios from "axios";

const instance = axios.create({
  baseURL: "https://discord-clone-demo.herokuapp.com",
});

export default instance;
